<!--新闻中心-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
        </div>
        <div class="top-container">
            <div class="flex-item new-icon">
                <svg t="1743067582413" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2868" width="30" height="30"><path d="M650.51445 512.388856h220.331711v129.183962H650.51445zM571.572675 291.452372c4.330623 13.694879 7.812927 27.396922 11.260438 41.087709l17.616181 72.357836c5.637383 22.815589 9.122757 34.989839 10.213599 41.730344l30.85569-0.016373c3.489467-13.469753 6.514354-23.02025 9.331511-33.018955l16.104761-54.11437h0.422624l13.490219 54.10209c2.611472 10.65055 5.000887 21.318495 7.608266 33.047608l33.006676-0.016373c2.648311-13.033825 5.460351-23.889035 7.394396-31.059328l16.309421-60.861014c7.821114-28.906296 14.545245-53.89129 18.034713-63.228941l-31.061375-0.012279c-1.51142 12.825071-3.49356 20.658464-6.77325 34.782108l-15.387424 64.533653h-0.451278l-13.460542-59.533789c-3.698221-16.969453-6.769157-30.639773-8.284671-42.809929l-36.94742 7.151873 3.489468 15.002662-19.964664 79.319375h-0.463557l-12.15583-53.687653c-3.903905-17.158764-6.978934-30.621353-8.071823-44.746021l-42.116129-0.010233z m-103.039566 0c2.192941 22.380685 2.183731 40.656897 2.183732 77.593061 0.008186 36.931047 0 55.202143-2.183732 77.583851l98.876764-0.016373v-27.166678c-9.331511 1.305736-33.888764 2.844786-58.438853 2.19601-0.205684-4.351089-0.459464-12.609154-0.459464-20.863125 0-8.270344 0.25071-16.518176 0.459464-20.863125 17.374681-0.00614 29.977695 0 39.099428 1.085726v-26.517904c-9.121733 1.079586-21.733957 1.093912-39.099428 1.093912-0.205684-4.138242-0.459464-12.170156-0.459464-19.995363 0-7.846696 0.25071-15.869401 0.459464-19.781493l9.549474-0.002046c13.033825 0 28.704705 0.002047 45.650622 2.613519l0.008186-26.959972h-95.646193z m-133.427605 0c2.188848 22.380685 2.179638 40.656897 2.179638 77.593061 0.008186 36.931047 0 55.202143-2.183731 77.583851l31.738802-0.016373c-2.183731-22.380685-2.187824-40.624152-2.187825-77.567478l0.004094-16.528409h0.422624l53.262981 94.095887h30.437159c-2.192941-22.380685-2.192941-40.624152-2.192941-77.567478 0-36.940257 0-55.200096 2.183731-77.580781l-31.733685-0.01228c2.183731 22.380685 2.183731 40.656897 2.183731 77.593061v10.429516h-0.459463l-49.978175-88.022577h-33.67694zM772.134149 440.311404c11.104897 4.993724 28.248311 9.36221 43.467914 9.36221 37.374138-0.014326 59.777335-23.902338 59.777335-52.586577 0.004093-16.098621-5.887069-32.163473-29.131423-43.254043-26.52916-12.609154-36.283295-15.427333-36.283295-26.945645 0.004093-6.964608 5.637383-14.122621 17.824935-14.122621 12.151737-0.01228 24.554183 6.517424 34.094448 14.559571l0.004093-33.906159c-10.007915-3.04433-20.222537-4.993724-30.650006-4.993725-30.850574 0-57.802358 19.118391-57.802358 49.327354 0.004093 21.727817 13.239509 33.690243 35.228268 44.111572 19.75898 9.339697 28.880713 13.045081 28.880714 25.217284 0.005117 10.210529-9.121733 16.948987-21.941688 16.948987-19.546133-0.004093-38.46805-16.294072-43.470984-21.079042l0.002047 37.360834zM193.784131 626.817796h-1.191126v54.974969h1.191126v205.915401h-66.937395l-0.34076-0.008186c-16.269513-0.049119-32.665915-3.14052-47.966359-9.290578C37.892953 862.074397 6.150058 825.134141 6.150058 767.721661V315.930831c0-35.373578 19.881776-58.213727 45.314978-68.359787 9.507519-3.789295 19.549203-5.695711 29.427157-5.695711l0.004094-0.004093h112.887844v54.972922H79.639669v0.026606c-2.92665 0.12075-5.636359 0.656961-7.993029 1.599424-5.928001 2.348483-10.510357 8.135268-10.510357 17.467802v-0.00614V767.713475c0 31.368366 16.561154 51.274701 37.793693 59.801895 8.621337 3.460815 18.198441 5.209641 27.90755 5.209641 9.758228-0.01228 19.298493-1.736547 27.95667-5.209641 21.233561-8.53538 38.984818-28.413063 38.984818-59.794732l0.004093-85.928896v-54.973946zM348.895551 744.6175c-7.233737 0-13.079874-5.83795-13.079874-13.047128 0-7.213271 5.842043-13.055314 13.070664-13.055314l125.487789-0.023536c7.188712 0 13.07578 5.873766 13.07578 13.07885 0 7.200991-5.887069 13.063501-13.079874 13.063501l-125.474485-0.016373z m0-51.510061c-7.233737 0-13.079874-5.854323-13.079874-13.059408 0-7.221457 5.842043-13.063501 13.070664-13.0635l125.487789-0.004094c7.188712 0 13.07578 5.858416 13.07578 13.067594 0 7.192805-5.887069 13.059408-13.079874 13.059408H348.895551z m0-51.534621c-7.233737 0-13.079874-5.85023-13.079874-13.059407 0-7.221457 5.842043-13.055314 13.070664-13.055315l125.487789-0.008186c7.188712 0 13.07578 5.854323 13.07578 13.063501 0 7.196898-5.887069 13.059408-13.079874 13.059407H348.895551z m0-51.529503c-7.233737 0-13.079874-5.85023-13.079874-13.051222 0-7.228621 5.842043-13.067594 13.070664-13.067594l125.487789-0.004093c7.188712 0 13.07578 5.854323 13.07578 13.070664 0 7.188712-5.887069 13.055314-13.079874 13.055314l-125.474485-0.003069z m0-51.550994c-7.233737 0-13.079874-5.832834-13.079874-13.042011 0-7.217364 5.842043-13.053268 13.070664-13.053268l125.487789-0.008186c7.188712 0 13.07578 5.860463 13.07578 13.061454 0 7.195875-5.887069 13.059408-13.079874 13.059407l-125.474485-0.017396zM542.478091 744.6175c-7.188712 0-13.034848-5.83795-13.034848-13.047128 0-7.213271 5.842043-13.055314 13.034848-13.055314l125.486765-0.023536c7.226574 0 13.071687 5.873766 13.071687 13.07885 0 7.200991-5.846137 13.063501-13.07578 13.063501l-125.482672-0.016373z m0-51.510061c-7.188712 0-13.034848-5.854323-13.034848-13.059408 0-7.221457 5.842043-13.063501 13.034848-13.0635l125.486765-0.004094c7.226574 0 13.071687 5.858416 13.071687 13.067594 0 7.192805-5.846137 13.059408-13.07578 13.059408H542.478091z m0-51.534621c-7.188712 0-13.034848-5.85023-13.034848-13.059407 0-7.221457 5.842043-13.055314 13.034848-13.055315l75.500404-0.008186c7.232714 0 13.070664 5.854323 13.070664 13.063501 0.008186 7.196898-5.842043 13.059408-13.070664 13.059407h-75.500404z m0-51.529503c-7.188712 0-13.034848-5.85023-13.034848-13.051222 0-7.228621 5.842043-13.067594 13.034848-13.067594l75.500404-0.004093c7.232714 0 13.070664 5.854323 13.070664 13.070664 0.008186 7.188712-5.842043 13.055314-13.070664 13.055314l-75.500404-0.003069z m0-51.550994c-7.188712 0-13.034848-5.832834-13.034848-13.042011 0-7.217364 5.842043-13.053268 13.034848-13.053268l75.500404-0.008186c7.232714 0 13.070664 5.860463 13.070664 13.061454 0.008186 7.195875-5.842043 13.059408-13.070664 13.059407l-75.500404-0.017396zM736.105656 744.6175c-7.225551 0-13.074757-5.83795-13.074757-13.047128 0.004093-7.213271 5.846137-13.055314 13.074757-13.055314l125.487788-0.023536c7.187688 0 13.070664 5.873766 13.070664 13.07885 0 7.200991-5.882976 13.063501-13.074757 13.063501l-125.483695-0.016373z m0-51.510061c-7.225551 0-13.074757-5.854323-13.074757-13.059408 0.004093-7.221457 5.846137-13.063501 13.074757-13.0635l125.487788-0.004094c7.187688 0 13.070664 5.858416 13.070664 13.067594 0 7.192805-5.882976 13.059408-13.074757 13.059408H736.105656z" fill="#3b62f8" p-id="2869"></path><path d="M192.594028 296.843139v590.865027h704.560259c31.742895 0 63.825527-11.519335 87.020762-34.546748 20.391382-20.23891 33.675916-48.803422 33.675916-85.447943l-0.004093-603.928529c0-15.175601-12.27044-27.493113-27.489019-27.493112l-770.273782 0.006139c-15.177647 0-27.489019 12.291929-27.48902 27.480833v133.064333h-0.001023z m54.982132 470.870336V191.266803H962.908742V767.713475c0 20.658464-6.856138 36.13594-17.41152 46.571595-12.356398 12.290906-30.223288 18.444034-48.343958 18.444034l-666.762474 0.004093c10.751857-17.525107 17.184347-39.201759 17.184347-65.011536v-0.008186z" fill="#3b62f8" p-id="2870"></path><path d="M193.784131 626.817796h-38.138546V315.930831c0-6.829532-0.964976-13.923076-2.352576-19.818331l39.299996 0.730639-111.899333-0.738826 0.295735 0.008187c3.234664 0.038886 6.507191 1.299596 9.109454 2.356669 5.923908 2.358716 10.554359 8.137315 10.554359 17.461662l-0.004093 338.377008c0 15.173554 12.320582 27.484926 27.501299 27.484926h65.631658v-54.974969h0.002047zM80.539153 296.104313c-0.369413 0.002047-0.734732 0.01228-1.100052 0.026606v-0.026606h1.100052z" fill="#3b62f8" p-id="2871"></path></svg>
            </div>
            <div class="flex-item new-title">新闻资讯</div>
            <div class="flex-item new-type">
<!--                <el-radio-group v-model="newType" class="ml-4">-->
<!--                    <el-radio label="1" size="large">普通</el-radio>-->
<!--                    <el-radio label="2" size="large">名师</el-radio>-->
<!--                    <el-radio label="3" size="large">名校长</el-radio>-->
<!--                </el-radio-group>-->
            </div>
        </div>
        <div class="page-info-container">
            <div class="achieve-list-container">
                <div class="achieve-container" v-if="dataList&&dataList.length>0">
                    <div class="achieve-item-container" v-for="item in dataList" :key="item" @click="handleViewNews(item,'0')">
                        <div class="achieve-item" >
                            <div class="achieve-cover">
                                <img :src="item.cover" alt />
                            </div>
                            <div class="achieve-title">{{item.title}}</div>
                            <div class="achieve-studio">{{item.groupName}}</div>
                        </div>
                    </div>

                </div>
                <data-empty v-if="dataList&&dataList.length===0" title="暂无新闻资讯"/>
            </div>
            <div class="page-container" v-if="dataList&&dataList.length>0">
                <pageTag :background="true"
                         :pageSizes="[8, 12, 16]"
                         v-show="total > 0"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="pageAllNews" />
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {pageNews} from "@/api/admin/news";
export default {
    components: {
        pageTag, dataEmpty,
        homeHead,
    },
    name: "homeNewsCentre",
    data() {
        return {
            timestampToTime,
            activePath: "homeNewsCentre",
            queryParams: {
                pageNum: 1,
                pageSize: 8,
                newsType:'',
                status:1,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            newType:'',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageAllNews()
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        pageAllNews(){
            pageNews(this.queryParams).then(res=>{
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleViewNews(item,type){
            //参数传递
            let routeUrl = this.$router.resolve({
                path: "/lyedu/news",
                query: {
                    signno: item.newsId,
                    type:type
                }
            });
            window.open(routeUrl.href, '_blank')
        },
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
    }
}
.top-container{
    width: 100%;
    height: 40px;
    display: flex;
    background-color: #fff;
    padding-left: 20px;
    box-sizing: border-box;
}
.new-title{
    width: 200px;
    height: 40px;
    line-height: 45px;
    font-size: 16px;
    color: #3b62f8;
    font-weight: bold;
}
.new-icon{
    padding-right: 5px;
    margin-top: 8px;
}
.page-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
}
.achieve-list-container{
    width: 100%;
    height: calc(100vh - 180px)!important;
    margin: auto;
    overflow-x: hidden;
}
.achieve-container{
    width: 98%;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
}
.achieve-item-container{
    width: 25%!important;
    height: 230px;
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
}
.achieve-item{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: var(--el-box-shadow-light);
}
.achieve-cover{
    width: 100%;
    height: 160px;
    img{
        width: 100%;
        height: 100%;
    }
}
.achieve-title{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #3b62f8;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
}
.achieve-studio{
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #3b62f8;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.new-type{
    padding-right: 40px;
    box-sizing: border-box;
}

.flex-item:last-child{
    margin-left: auto;
}
</style>